var _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconServicesAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.489,31.29932a14.736,14.736,0,0,0-28.978,0A2.75,2.75,0,0,0,23.25,34v4A2.7528,2.7528,0,0,0,26,40.75h2a.7502.7502,0,0,0,.75-.75V32a.7502.7502,0,0,0-.75-.75h-.95459a13.2415,13.2415,0,0,1,25.90918,0H52a.7502.7502,0,0,0-.75.75v8a.7502.7502,0,0,0,.75.75h1.21094a7.259,7.259,0,0,1-6.58789,6.46851,2.74682,2.74682,0,1,0,.02,1.49878,8.75086,8.75086,0,0,0,8.07446-8.07422A2.746,2.746,0,0,0,56.75,38V34A2.75,2.75,0,0,0,54.489,31.29932ZM27.25,32.75v6.5H26A1.25116,1.25116,0,0,1,24.75,38V34A1.25116,1.25116,0,0,1,26,32.75ZM44,49.25A1.25,1.25,0,1,1,45.25,48,1.25116,1.25116,0,0,1,44,49.25ZM55.25,38A1.25116,1.25116,0,0,1,54,39.25H52.75v-6.5H54A1.25116,1.25116,0,0,1,55.25,34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,20A6.75769,6.75769,0,0,0,64,13.25H16A6.75769,6.75769,0,0,0,9.25,20V52A6.75769,6.75769,0,0,0,16,58.75H55.68945l7.78028,7.78027A.74993.74993,0,0,0,64.75,66V58.7085A6.7599,6.7599,0,0,0,70.75,52Zm-1.5,32A5.25605,5.25605,0,0,1,64,57.25a.7502.7502,0,0,0-.75.75v6.18945l-6.71973-6.71972A.74942.74942,0,0,0,56,57.25H16A5.25605,5.25605,0,0,1,10.75,52V20A5.25605,5.25605,0,0,1,16,14.75H64A5.25605,5.25605,0,0,1,69.25,20Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 36,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 36,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServicesAlt);
export default __webpack_public_path__ + "static/media/icon_services_alt.4bf20fa47ee5d9ae6b820a1c8220e777.svg";
export { ForwardRef as ReactComponent };